export const CommunicationEndpointTypeNameSet = new Set([
    'OneInstanceEndpoint',
    'Email',
    'PhoneNumber',
    'Address',
    'Website',
    'SocialMedia'
]);
/**
 * Checks if the endpoint is of a specific enpoint type.
 *
 * @param endpoint
 * @param type
 */
export function isEndpointOfType(endpoint, type) {
    return endpoint.$type$ === type;
}
// #### Recipes ####
export const OneInstanceEndpointRecipe = {
    $type$: 'Recipe',
    name: 'OneInstanceEndpoint',
    rule: [
        {
            itemprop: 'personId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'instanceId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Instance']) }
        },
        {
            itemprop: 'personKeys',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['Keys']) }
        },
        {
            itemprop: 'instanceKeys',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['Keys']) }
        },
        {
            itemprop: 'url',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
export const EmailRecipe = {
    $type$: 'Recipe',
    name: 'Email',
    rule: [
        {
            itemprop: 'email',
            itemtype: { type: 'string' }
        }
    ]
};
export const PhoneNumberRecipe = {
    $type$: 'Recipe',
    name: 'PhoneNumber',
    rule: [
        {
            itemprop: 'number',
            itemtype: { type: 'string' }
        }
    ]
};
export const AddressRecipe = {
    $type$: 'Recipe',
    name: 'Address',
    rule: [
        {
            itemprop: 'street',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'city',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'state',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'postalCode',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'country',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'label',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
export const WebsiteRecipe = {
    $type$: 'Recipe',
    name: 'Website',
    rule: [
        {
            itemprop: 'url',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'label',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
export const SocialMediaRecipe = {
    $type$: 'Recipe',
    name: 'SocialMedia',
    rule: [
        {
            itemprop: 'platform',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'handle',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'url',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
// #### Reverse maps ####
export const CommunicationEndpointReverseMaps = [
    ['OneInstanceEndpoint', new Set(['*'])]
];
export default [
    OneInstanceEndpointRecipe,
    EmailRecipe,
    PhoneNumberRecipe,
    AddressRecipe,
    WebsiteRecipe,
    SocialMediaRecipe
];
//# sourceMappingURL=CommunicationEndpoints.js.map